import React from "react";
import "./Warehouse.css";
import { MoreHorizontal } from "react-feather";
import { useSelector } from "react-redux";
import { useSession } from "../../authentications/SessionContext";
import { useNavigate } from "react-router-dom";

const WarehouseList = () => {
  const navigate = useNavigate();
  const { changeview } = useSession();
  const { inventoryTypeList } = useSelector((state) => state.warehouse);

  return (
    <>
      <div className="WarehouseContainer">
        <div className="app_boards_container">
          <div className="app_boards">
            {inventoryTypeList?.map((column) => (
              <div key={column.id} className="board">
                <div className="board_header">
                  <div className="warehouse_header_title ">{column.name}</div>
                  <div className="warehouse_header_title_more">
                    <MoreHorizontal />
                  </div>
                </div>
                {column.count_picking_ready ||
                column.count_picking_waiting ||
                column.count_picking_late ||
                column.count_picking_backorders ? (
                  <div className="card ">
                    <div className="card-content-container d-flex align-items-center">
                      <button
                        onClick={() => {
                          changeview("taskList");
                          navigate(`/homepage/warehouse`, {
                            state: {
                              picking_type_id: column.id,
                              state: "to process",
                            },
                          });
                        }}
                        className="p-2 process_div border-0"
                      >
                        {column.count_picking_ready} to process
                      </button>
                      <div className="card_right_part">
                        {column.count_picking_waiting > 0 && (
                          <div
                            role="button"
                            onClick={() => {
                              changeview("taskList");
                              navigate(`/homepage/warehouse`, {
                                state: {
                                  picking_type_id: column.id,
                                  state: "to waiting",
                                },
                              });
                            }}
                            className="other_informations "
                          >
                            {column.count_picking_waiting} Waiting
                          </div>
                        )}
                        {column.count_picking_late > 0 && (
                          <div
                            role="button"
                            onClick={() => {
                              changeview("taskList");
                              navigate(`/homepage/warehouse`, {
                                state: {
                                  picking_type_id: column.id,
                                  state: "late",
                                },
                              });
                            }}
                            className="other_informations "
                          >
                            {column.count_picking_late} Late
                          </div>
                        )}
                        {column.count_picking_backorders > 0 && (
                          <div
                            role="button"
                            onClick={() => {
                              changeview("taskList");
                              navigate(`/homepage/warehouse`, {
                                state: {
                                  picking_type_id: column.id,
                                  state: "backorder_id",
                                },
                              });
                            }}
                            className="other_informations"
                          >
                            {column.count_picking_backorders} Back orders
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="defalult_card">
                    <div className="no-items">No items</div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default WarehouseList;
